import PageLayout from "./PageLayout";

function PageNotFound() {
  return (
    <PageLayout>
      <div className="text-center py-5">
        <h1 className="display-1">404</h1>
        <h4>Page Not Found</h4>
      </div>
    </PageLayout>
  );
}

export default PageNotFound;
